<template>
  <div>
    <el-dialog
      :title="formTitle"
      :visible.sync="dialogVisible"
      :before-close="close"
      :close-on-click-modal="false"
      width="700px"
    >
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-width="100px;"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.label_project_category') || '项目分类'"
              prop="prjCategoryCode"
            >
              <dict-select
                ref="dict_prjcategory"
                v-model="formData.prjCategoryCode"
                url="/digitalCenter/common/dict/prjCategory"
                :placeholder="
                  $l('INDEX.tips_select_project_category') || '请选择项目分类'
                "
                size="medium"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              v-if="isSubProject"
              :label="$l('INDEX.label_projectType') || '项目角色'"
              prop="projectType"
            >
              <el-select
                v-model="formData.projectType"
                filterable
                clearable
                :placeholder="
                  $l('INDEX.tips_select_projectType') || '请选择项目角色'
                "
                style="width: 100%"
                size="medium"
              >
                <el-option
                  v-for="item in projectTypeArray"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('INDEX.label_customer') || '客户'"
              prop="custCode"
            >
              <dict-select
                v-model="formData.custCode"
                url="/digitalCenter/common/dict/customer"
                size="medium"
                :disabled="customerDisable"
                :placeholder="$l('INDEX.tips_select_customer') || '请选择客户'"
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              :label="$l('label_prjOwnerCode') || '项目负责人'"
              prop="prjOwnerCode"
            >
              <dict-select
                v-model="formData.prjOwnerCode"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('tips_prjOwnerCode') || '请选择项目负责人'"
                size="medium"
                filterable
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.label_proofing_type') || '打样类型'"
              prop="sampleType"
              v-show="sampleTypeVisible"
            >
              <el-radio-group size="medium" v-model="formData.sampleType">
                <el-radio label="S">{{
                  $l('INDEX.label_proofing_sample') || '样品打样'
                }}</el-radio>
                <el-radio label="M">{{
                  $l('INDEX.label_proofing_fabric') || '面料打样'
                }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <b-button variant="outline-success" size="sm" @click="openGroup()"
          >选择分组</b-button
        >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('label_prjParticipant') || '项目参与人'"
              prop="prjParticipant"
            >
              <dict-select
                v-model="formData.prjParticipant"
                url="/digitalCenter/common/dict/baseUser"
                :placeholder="$l('tips_prjParticipant') || '请选择项目参与人'"
                size="medium"
                filterable
                :multiple="true"
                clearable
                :options="{ label: 'label', value: 'code' }"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="reset">{{
          $l('INDEX.btn_reset') || '重置'
        }}</el-button>
        <el-button type="primary" size="small" @click="save">{{
          $l('INDEX.btn_next') || '下一步'
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 人员分组 dialog -->
    <el-dialog
      :title="$l('card_personnel_group_title') || '人员分组'"
      :visible.sync="groupDialogVisible"
      :close-on-click-modal="false"
      width="800px"
      :before-close="() => (groupDialogVisible = false)"
      v-if="groupDialogVisible"
    >
      <group-table ref="groupTable" @close="closeGroup()" />
      <span slot="footer">
        <el-button size="small" @click="groupDialogVisible = false">{{
          $l('btn_cancel') || '取消'
        }}</el-button>
        <el-button type="primary" size="small" @click="confirm()">{{
          $l('INDEX.tips_confirm') || '确认'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import GroupTable from '../group'
export default {
  components: { GroupTable },
  data() {
    return {
      formTitle: '',
      groupDialogVisible: false,
      dialogVisible: false,
      sampleTypeVisible: false,
      customerDisable: false,
      isSubProject: false,
      projectTypeArray: [],
      formData: {
        prjCategoryCode: '',
        masterCategoryCode: '',
        projectType: '',
        custCode: '',
        linkPrjCode: '',
        topPrjCode: '',
        sampleType: 'N',
      },
      rules: {
        prjCategoryCode: [
          { required: true, message: '请选择项目分类', trigger: 'blur' },
        ],
        sampleType: [{ required: true }],
        custCode: [{ required: true, message: '请选择客户', trigger: 'blur' }],
      },
    }
  },
  watch: {
    'formData.prjCategoryCode'(val) {
      if (!val) {
        this.sampleTypeVisible = false
        return
      }
      let selected = this.$refs.dict_prjcategory.selected
      this.sampleTypeVisible = selected.isSample === 'Y'
    },
  },
  methods: {
    // 加载表单数据（新增项目，新增子项目）
    fromLoad(ref, val = {}) {
      this.formTitle = val.formTitle
      this.getProjectTypeArray()
      if (ref === 'addsub') {
        this.formData.linkPrjCode = val.linkPrjCode
        this.formData.topPrjCode = val.topPrjCode
        this.formData.custCode = val.custCode
        this.customerDisable = true
        this.isSubProject = true
      }
      this.dialogVisible = true
    },
    load() {
      this.dialogVisible = true
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.projectInfoAddApi(this.formData).then((res) => {
            this.$router.push({
              name: 'projectManagement-projectInfo-edit',
              params: {
                pageType: 'add',
                prjCode: res.body,
              },
            })
            this.close()
          })
          return ''
        }
      })
    },
    close() {
      this.reset()
      this.dialogVisible = false
    },
    reset() {
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },
    getProjectTypeArray() {
      this.$api.systemDict({ dictType: 'projectType' }).then((res) => {
        this.projectTypeArray = res.body.data.map((item) => {
          return {
            label: item.label,
            value: item.value,
          }
        })
      })
    },
    // 打开选取分组弹框
    openGroup() {
      this.groupDialogVisible = true
    },
    closeGroup() {
      this.groupDialogVisible = false
    },
    async confirm() {
      const chckedData = this.$refs.groupTable.getTableRadioChecked()
      if (!chckedData) {
        this.$message({
          showClose: true,
          message: '请选择一组成员',
          type: 'warning',
        })
        return
      }
      this.formData.prjParticipant = await chckedData.userList.map((i) => {
        return i.userCode
      })
      this.groupDialogVisible = false
    },
  },
}
</script>
